/**
 * QuestionFocusButton
 *
 * A button component to launch the QuestionFocusMode in messages
 *
 * Primary responsibilities:
 * - Provide a button to launch question focus mode
 * - Manage focus mode dialog state
 */

import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import { IconSearch } from '@tabler/icons-react'
import { QuestionFocusMode, QuestionItem } from './question-focus-mode'

interface QuestionFocusButtonProps {
  questions: QuestionItem[]
}

export const QuestionFocusButton: React.FC<QuestionFocusButtonProps> = ({ questions }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        size="sm"
        variant="outline"
        className="mb-4 mt-2 flex items-center gap-2"
        onClick={() => setIsOpen(true)}
      >
        <IconSearch size={16} />
        <span>Open Questions in Focus Mode ({questions.length})</span>
      </Button>

      <QuestionFocusMode questions={questions} isOpen={isOpen} onOpenChange={setIsOpen} />
    </>
  )
}
